<template>
  <div class="app" v-show="isLoggedIn">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          :src="logo"
          width="89"
          height="30"
          alt=""
        />
        <img
          class="navbar-brand-minimized"
          :src="loguito"
          width="25"
          height="30"
          alt="Aldea Global"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="md" :defaultOpen="true" />
      <b-navbar-nav class="d-md-down-none" type="dark" variant="info">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item-dropdown
          class="px-3"
          id="my-nav-dropdown"
          text="Operaciones"
          toggle-class="nav-link-custom"
          variant="primary"
        >
          <b-dropdown-item to="/comprobantes-diario">
            <i class="icon-note" />Comprobantes Diario
          </b-dropdown-item>
          <b-dropdown-item to="/cheques-transferencias">
            <i class="icon-wallet" />Cheques - Transferencias
          </b-dropdown-item>
           <b-dropdown-item to="/comprobantes-automaticos">
           <i class="fa fa-microchip" />Comprobantes Automáticos
          </b-dropdown-item>
          <b-dropdown-item to="/cierre-mensual">
            <i class="fa fa-book" />Cerrar Mes
          </b-dropdown-item>
         <!-- <b-dropdown-item to="/cierre-mensual">
            <i class="fa fa-book" />Cierre Fiscal
          </b-dropdown-item>
          <b-dropdown-item to="/cierre-mensual">
            <i class="fa fa-book" />Cierre Financiero
          </b-dropdown-item> -->
          <b-dropdown-item to="/conciliacion">
            <i class="fa fa-check" />Conciliación Bancaria
          </b-dropdown-item>

        </b-nav-item-dropdown>
     <!--   <b-nav-item-dropdown
          class="px-3"
          id="my-nav-dropdown"
          text="Catalogos"
          toggle-class="nav-link-custom"
          variant="primary"
        >
        <b-dropdown-item to="/catalogos/muc"><i class="icon-notebook"></i> Catalogo MUC</b-dropdown-item>
          <b-dropdown-item to="/catalogos/niif"><i class="icon-notebook"></i> Catalogo NIIF</b-dropdown-item>
          <b-dropdown-item to="/catalogos/homologacion"><i class="icon-notebook"></i> Homologacion MUC a NIIF</b-dropdown-item>
         <b-dropdown-divider></b-dropdown-divider>

        </b-nav-item-dropdown>-->
        <b-nav-item-dropdown
          class="px-3"
          text="Reportes"
          toggle-class="nav-link-custom"
          variant="primary"
        >
          <b-dropdown-item v-show="empresa_id == 1" to="/reportes/comparativa"><i class="fa fa-eye"></i>Cartera vs PaCo</b-dropdown-item>
          <b-dropdown-item to="/reportes/diario"><i class="fa fa-calendar"></i> Libro Diario</b-dropdown-item>
          <b-dropdown-item to="/reportes/aux-diario"><i class="fa fa-calendar"></i> Auxiliar por Cuenta</b-dropdown-item>
          <b-dropdown-item to="/reportes/mayor"><i class="fa fa-calendar-o"></i> Libro Mayor</b-dropdown-item>
          <b-dropdown-item to="/reportes/bcomprobacion"><i class="fa fa-check-square-o"></i> Balanza Comprobación</b-dropdown-item>
          <b-dropdown-item to="/reportes/estados-financieros"><i class="fa fa-book"></i> Estados Financieros</b-dropdown-item>
          <b-dropdown-item to="/reportes/estados-financieros-mensuales"><i class="fa fa-book"></i> EEFF Acumulado Mensual</b-dropdown-item>
          <b-dropdown-item to="/tipo-cambio">
            <i class="fa fa-money"></i> Tipo Cambio Dolares Cordobas
          </b-dropdown-item>
       </b-nav-item-dropdown>
        <b-nav-item-dropdown
          class="px-3"
          id="my-nav-dropdown"
          text="Configuraciones"
          toggle-class="nav-link-custom"
          variant="primary"
        >
        <b-dropdown-item to="/catalogos"><i class="icon-notebook"></i> Catalogos de Cuentas</b-dropdown-item>
          <b-dropdown-item to="/empresas">
            <i class="fa fa-list" />Empresas
          </b-dropdown-item>
          <b-dropdown-item to="/centros">
            <i class="fa fa-list" />Centros
          </b-dropdown-item>
          <b-dropdown-item to="/cuentas-cks">
            <i class="fa fa-list"></i> Cuentas para Cheques
          </b-dropdown-item>
        <b-dropdown-item to="/users"><i class="fa fa-users"></i> Usuarios</b-dropdown-item>
      <!--  <b-dropdown-item to="/config/reportes-create"><i class="fa fa-file"></i> Diseñar Reportes</b-dropdown-item>-->
        </b-nav-item-dropdown>

      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
      <b-form-select
      id="empresa"
      v-model="empresa_id"
      @change="changeEmpresa"
      :options="getEmpresas"

       class="mt-3">
       </b-form-select>
      </b-navbar-nav>
      <b-navbar-nav>
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav" :class="class_color"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer :class="class_color" />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside
        <DefaultAside /> -->
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div class="ml-auto">
        <span class="mr-1">&copy; Aldea Global - Todos los Derechos Reservados</span>
      </div>
    </TheFooter>
    <TimerLogOut></TimerLogOut>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../router";
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import TimerLogOut from "../views/notifications/TimerLogOut";

export default {
  created() {
    if (!this.isLoggedIn) {
      return router.push("/login");
    }

    this.empresa_id = this.empresaId;
  },
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
 //   DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    TimerLogOut
  },
  data() {
    return {
      nav: nav.items,
       empresa_id: undefined,

    };
  },
  computed: {
    ...mapGetters("authentication", ["isLoggedIn", "getEmpresas", "empresaId"]),
    name() {
      return this.$route.name;
    },
    empresaSeleccionada(){
      let empresas =  JSON.parse(JSON.stringify(this.getEmpresas));
      console.dir("las empresas son: ", empresas);
      let empresa_seleccionada = empresas.find((element) => parseInt(element.value) === parseInt(this.empresaId));
       console.log("la empresa seleccionada es: ",empresa_seleccionada);
       return empresa_seleccionada;
    },
    
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    loguito(){
      return '/img/brand/imagotipo_ag.png';
    },    
    logo(){
      return '/img/brand/'+this.empresaSeleccionada.logo;
    },
    class_color(){
      return this.empresaSeleccionada.color_class;
    }
  },
  methods:{
    ...mapActions("authentication", ["setEmpresa"]),
  changeEmpresa(){
    this.setEmpresa(this.empresa_id);
      if(this.name !== 'Dashboard')
        this.$router.push('/dashboard');
      else
        location.reload();
  }
  }
};
</script>
<style>
@media (max-width: 799px) {
  .navbar-brand-full{
  display: none;
  }
  #empresa{
    position: relative;
    left: -3.2em;
    margin-bottom: 1.2em;
  }
}
@media (min-width: 800px) {
  #empresa{

    margin-bottom: 0.7em;
  }
}

.default{
  background-color:#3a4248;
}
.az{
  background-color: rgb(3, 122, 173);

}
.coffee{
  background-color: rgb(89, 56, 18);
}

.green{
  background: rgb(0, 105, 56) !important;
}

.az > section > ul > li.nav-item > a.router-link-exact-active.open.active.nav-link:first-child {

    background: #3aa8d7 !important;
}

.az > .sidebar .nav-link .active{
  color:black;
  background: #3aa8d7 !important;
}
 
.default > section > ul > li.nav-item > a.router-link-exact-active.open.active.nav-link:first-child {

    background: #3aa8d7 !important;
}
.default > .sidebar .nav-link.active{
  background: #3aa8d7 !important;
}

.coffee > section > ul > li.nav-item > a.router-link-exact-active.open.active.nav-link:first-child {
    background: rgb(89, 56, 18) !important;
}
.coffee > .sidebar .nav-link.active{
  background: rgb(89, 56, 18) !important;
}

.green > section > ul > li.nav-item > a.router-link-exact-active.open.active.nav-link:first-child {
    background: rgb(0, 105, 56) !important;
}
.green > .sidebar .nav-link.active{
  background: rgb(0, 105, 56) !important;
}

</style>
